module.exports = __webpack_public_path__ + "design.jpg?3766443b788a03a01289b857a6c390b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/design.jpg
// module id = 51
// module chunks = 0